// initial state
const state = () => ([])

// getters
const getters = {
    getStateCalendarHoursDropdown(state) {
        if(_.isEmpty(state)) {
            const newState = JSON.parse(localStorage.getItem('@datadrive:backoffice-hours-calendar-drop'));
            if(newState !== null && newState !== undefined) {
                mutations.setCalendarHoursDropdowns(state, newState);
                return newState;
            } else {
                return state;
            }
        } else {
            return state;
        }
    },
}

// actions
const actions = {}

// mutations
const mutations = {
    setCalendarHoursDropdowns(state, payload) {
      for (var [key, value] of Object.entries(payload)) {
          state[key] = value;
      }

      localStorage.setItem('@datadrive:backoffice-hours-calendar-drop', JSON.stringify(state));
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
